import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = '5. Network Log Analysis: Determine Compromised System';
  const flag = '192.168.134.130';
  const hints = [
    (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Sparkle Redberry]  </Text><a rel="noopener noreferrer" target="_blank" href='https://www.activecountermeasures.com/free-tools/rita/'>RITA</a></Flex>),
     ];
  const assignment = 'The attacks don\'t stop! Can you help identify the IP address of the malware-infected system using these Zeek logs? For hints on achieving this objective, please visit the Laboratory and talk with Sparkle Redberry.';
  const data = useStaticQuery(graphql`
    query {
      rita: file(relativePath: { eq: "rita.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code5_3: file(relativePath: { eq: "code5_3.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code5_1: file(relativePath: { eq: "code5_1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code5_2: file(relativePath: { eq: "code5_2.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code5_4: file(relativePath: { eq: "code5_4.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }

    }
  `)
  return (
    <Entry
      title={title}
      hints={hints}
      flag={flag}
      assignment={assignment}
    >
     <Text my={2}>We will run Rita with <code>docker-compose</code> (on Mac). For that we need to clone <code>https://github.com/activecm/rita</code> and put the unzipped 'elfu-zeeklogs' to that folder</Text>
     <Text my={2}>Next step: modify <code>rita/etc/rita.yaml</code> -> uncomment a few things</Text>
     <Img fluid={data.code5_1.childImageSharp.fluid}
             style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
             imgStyle={{ objectFit: 'contain' }}
     />

     <Text my={2}>Also need to modify <code>rita/docker-compose.yaml</code> -> add the paths</Text>
     <Img fluid={data.code5_2.childImageSharp.fluid}
             style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
             imgStyle={{ objectFit: 'contain' }}
     />

     <Text my={2}>Action time! Run rita to build a db named 'result'</Text>
     <Img fluid={data.code5_3.childImageSharp.fluid}
             style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
             imgStyle={{ objectFit: 'contain' }}
     />

     <Text my={2}>According to Rita docs <code>show-beacons</code> helps find IPs that excibit C2 behavior.</Text>
     <Img fluid={data.code5_4.childImageSharp.fluid}
             style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
             imgStyle={{ objectFit: 'contain' }}
     />

     <Text my={2}>produces</Text>
     <Img fluid={data.rita.childImageSharp.fluid}
             style={{ margin: 0,  maxHeight: '70vh', width: '70vw' }}
             imgStyle={{ objectFit: 'contain' }}
     />
     <Text my={2}>The IP with highest score (0.998) is the one! It had the biggest number of outgoing connections, which is suspicious.</Text>
    </Entry>
  )

};
